module.exports = __webpack_public_path__ + "static/media/2019_IMG_9624.871af234.jpg";